import braintree from 'braintree-web';
import braintreeAuthorizationToken from '../mock/braintreeAuthorizationToken';

const getUserDeviceData = async () => {
  try {
    // Create a Braintree client instance
    const clientInstance = await braintree.client.create({
      authorization: braintreeAuthorizationToken,
    });

    // Create a data collector instance
    const dataCollectorInstance = await braintree.dataCollector.create({
      client: clientInstance,
    });

    // Return the device data
    return dataCollectorInstance.deviceData;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error retrieving device data:', error);
    return null;
  }
};

export default getUserDeviceData;
